<template>
  <v-sheet :color="$vuetify.theme.dark ? 'transparent ' : 'transparent'">
    <v-row dense>
      <v-col cols="12" xl="12" class="custom-border">
        <v-card elevation="0" class="rounded-0 mb-0" :color="$vuetify.theme.dark ? 'transparent ' : 'transparent'">
          <v-tabs :background-color="$vuetify.theme.dark ? 'transparent ' : 'transparent'"
            class="pa-0 commission-settings-tabs">
            <v-tab class="ml-0 pt-1"> KYC Verification & Access </v-tab>
            <v-tab>Trading Accounts T&C</v-tab>
            <v-tab>Others T&C</v-tab>
            <v-tab>Client’s Agreement History</v-tab>
            <v-tab-item>
              <v-card flat class="mb-0 pt-2" :color="$vuetify.theme.dark ? 'transparent ' : 'transparent'">
                <verification-tab></verification-tab>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <trading-account-tab></trading-account-tab>
            </v-tab-item>
            <v-tab-item>
              <OthersTab />
            </v-tab-item>
            <v-tab-item>
              <agreement-tab></agreement-tab>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import TradingAccountTab from './TradingAccountsTab.vue';
import VerificationTab from "./VerificationTab.vue";
import AgreementTab from "./AgreementTab.vue";
import OthersTab from './OthersTab.vue';

export default {
  data: () => ({}),
  components: {
    VerificationTab,
    TradingAccountTab,
    AgreementTab, OthersTab
  },
};
</script>
